import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  navBar,
  mainBody,
  about,
  repos,
  leadership,
  skills,
  getInTouch,
  experiences,
} from "./editable-stuff/config.js";
import MainBody from "./components/home/MainBody";
import AboutMe from "./components/home/AboutMe";
import Project from "./components/home/Project";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Skills from "./components/home/Skills";
// import { Blog } from "./components/blog/Blog";
// import BlogPost from "./components/blog/BlogPost";
import GetInTouch from "./components/home/GetInTouch.jsx";
import Leadership from "./components/home/Leadership.jsx";
import Experience from "./components/home/Experience";
import Portfolio from "./components/home/Portforlio.jsx";

const Home = React.forwardRef((props, ref) => {
  const { isDarkMode } = props;
  return (
    <>
      <MainBody
        gradient={isDarkMode ? mainBody.darkColors : mainBody.gradientColors}
        title={`${mainBody.firstName} ${mainBody.middleName} ${mainBody.lastName}`}
        message1={mainBody.message1}
        message2={mainBody.message2}
        icons={mainBody.icons}
        ref={ref}
        isDarkMode={isDarkMode}
      />
      {about.show && (
        <AboutMe
          heading={about.heading}
          message={about.message}
          link={about.imageLink}
          imgSize={about.imageSize}
          resume={about.resume}
          isDarkMode={isDarkMode}
        />
      )}
      {experiences.show && (
        <Experience experiences={experiences} isDarkMode={isDarkMode} />
      )}
      {about.show && <Portfolio isDarkMode={isDarkMode} />}
      {repos.show && (
        <Project
          heading={repos.heading}
          username={repos.gitHubUsername}
          length={repos.reposLength}
          specfic={repos.specificRepos}
          publicRepos={repos.otherRepos}
          isDarkMode={isDarkMode}
        />
      )}
      {leadership.show && (
        <Leadership
          heading={leadership.heading}
          message={leadership.message}
          img={leadership.images}
          imageSize={leadership.imageSize}
          isDarkMode={isDarkMode}
        />
      )}
      {skills.show && (
        <Skills
          heading={skills.heading}
          hardSkills={skills.hardSkills}
          softSkills={skills.softSkills}
          isDarkMode={isDarkMode}
        />
      )}
    </>
  );
});

const App = () => {
  const titleRef = React.useRef();

  const [isDarkMode, setIsDarkMode] = useState(true);

  const handleToggleClick = () => setIsDarkMode(!isDarkMode);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL + "/"}>
      {navBar.show && (
        <Navbar
          ref={titleRef}
          isDarkMode={isDarkMode}
          handleToggleClick={handleToggleClick}
        />
      )}
      <Routes>
        <Route
          path="/"
          //exact
          element={<Home ref={titleRef} isDarkMode={isDarkMode} />}
        />
        {/* {false && <Route path="/blog" exact element={Blog} />}
        {false && <Route path="/blog/:id" element={BlogPost} />} */}
      </Routes>
      <Footer isDarkMode={isDarkMode}>
        {getInTouch.show && (
          <GetInTouch
            heading={getInTouch.heading}
            message={getInTouch.message}
            email={getInTouch.email}
          />
        )}
      </Footer>
    </BrowserRouter>
  );
};

export default App;
